"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "8", height: "5", viewBox: "0 0 8 5", className: "Icon menu-down-arrow", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement("path", { d: "M0 0h8L4 5z", fill: "#929292", fillRule: "evenodd" })
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/large/jsx/menu-down-arrow.js
// module id = 1812
// module chunks = 0